import React from "react";
import VittVichaarImage from "../../assets/vitt-vichaar/vitt-vichaar.webp";

export default function Hero() {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-12 md:px-8 ">
        <div className="flex justify-center">
          <img
            src={VittVichaarImage}
            className="w-full h-auto max-h-[500px] md:max-h-[600px] object-contain"
            alt="img"
          />
        </div>
        <div className="flex flex-col justify-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center md:text-left">
            Project Vitt Vichaar
          </h1>
          <p className="mt-6 text-center md:text-left">
            <span className="text-2xl font-bold text-[#eab02a]">
              About Vitt Vichaar
            </span>
            <br />
            <span className="text-[#257377] text-lg underline italic">
              Money Simplified
            </span>
            <br />
            <span className="text-[#257377] text-lg">
              <strong>Project Vitt Vichaar</strong> is an initiative by{" "}
              <strong>LEO Club, University of Delhi</strong>, dedicated to
              promoting financial literacy with the empowering motto — "Money
              Simplified." The project aims to educate individuals, especially
              those from underprivileged backgrounds, about the importance of
              financial awareness and independence. By equipping people with
              essential financial knowledge and practical tools, Project Vitt
              Vichaar aspires to help them take control of their finances and
              make informed decisions for a secure future
              <br />
              <br />
              From understanding the basics of saving and budgeting to exploring
              the world of investments and digital finance,{" "}
              <strong>Vitt Vichaar</strong>
              simplifies complex concepts into accessible, practical
              knowledge.The project’s key initiatives include the{" "}
              <strong>VittByte</strong>
              educational series on Instagram,{" "}
              <strong>
                offline financial literacy sessions, in-house skill development
                workshops
              </strong>{" "}
              for members, distribution of <strong>financial toolkits</strong>,
              the <strong>“Decoding Sociopreneurs”</strong>
              podcast series, and a regular <strong>newsletter</strong> to keep
              the Leo community informed and inspired. Through these efforts,
              Project Vitt Vichaar strives to make financial wisdom accessible,
              actionable, and inclusive for all.
            </span>
            <br />
            <br />
            <span className="text-2xl font-bold text-[#eab02a]">
              Foundation & Objectives
            </span>
            <br />
            <span className="text-[#257377] text-lg">
              Focuses on spreading financial literacy by providing practical and
              theoretical knowledge through its well-versed modules with future
              prospects of expanding in the area of providing pro-bono
              fundraising services as well.
            </span>
            <br />
            <br />
            <span className="text-2xl font-bold text-[#eab02a]">UNSDGS</span>
            <br />
            <span className="text-[#257377] text-lg">
              We target (directly &/or Indirectly) :
              <br />
              <span className="italic font-semibold">UNSDG 4: </span>Quality
              Education
              <br />
              <span className="italic font-semibold">UNSDG 5: </span>Gender
              Equality
              <br />
              <span className="italic font-semibold">UNSDG 8:</span> Decent work
              & Economic growth
              <br />
              <span className="italic font-semibold">UNSDG 17:</span>{" "}
              Partnership for Goals
            </span>
          </p>
        </div>
      </div>
    </>
  );
}
